module.exports = "<input\n  class=\"text\"\n  type=\"text\"\n  value=\"{{section.title}}\"\n  [attr.disabled]=\"!section.isEditable ? '' : null\"\n  [class._is-active]=\"isSectionActive\"\n  (click)=\"onSectionInputClick($event)\"\n  (blur)=\"stopSectionEdit($event, section)\"\n  (keyup)=\"onSectionInputKeyUp($event, section)\"\n  #input\n>\n"


//////////////////
// WEBPACK FOOTER
// /Users/nide/Code/3dissue/3d-issue-hubs-ui/src/app/edit/sections-panel/auto-focus-input/auto-focus-input.component.html
// module id = ../../../../../src/app/edit/sections-panel/auto-focus-input/auto-focus-input.component.html
// module chunks = main